import React from 'react';
import './ActivitySummary.css';
import summaryIconOne from '../../assets/activity_summary_one.svg';
import summaryIconTwo from '../../assets/activity_summary_icon_two.svg';
import summaryIconThree from '../../assets/activity_summary_icon_three.svg';
const ActivitySummary = ({ activitySummary }) => {
	console.log('Activity Summary:', activitySummary);
	return (
		<div>
			{/* <h3 className="summary-title">Activity Summary</h3> */}
			<div className="summary-content">
				<div className="summary-item">
					{/* <span className="summary-icon blue">🧠</span> */}
					<img src={summaryIconOne} alt="File" className="file-icon" />
					<span className="summary-text">
						Total KCs Mastered: <strong>{activitySummary.totalKCMastered}</strong>
					</span>
				</div>
				<div className="summary-item">
					{/* <span className="summary-icon green">🟩</span> */}
					<img src={summaryIconTwo} alt="File" className="file-icon" />
					<span className="summary-text">
						Total Questions Attempted:{' '}
						<strong>{activitySummary.totalQuestionsAttempted}</strong>
					</span>
				</div>
				<div className="summary-item">
					{/* <span className="summary-icon red">💾</span> */}
					<img src={summaryIconThree} alt="File" className="file-icon" />
					<span className="summary-text">
						Total Study Time: <strong>{activitySummary.totalStudyTime}</strong>
					</span>
				</div>
			</div>
		</div>
	);
};

export default ActivitySummary;
